import { render, staticRenderFns } from "./SysTeacherAvailabilityCustomRange.vue?vue&type=template&id=605382b4"
import script from "./SysTeacherAvailabilityCustomRange.vue?vue&type=script&lang=js"
export * from "./SysTeacherAvailabilityCustomRange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('605382b4')) {
      api.createRecord('605382b4', component.options)
    } else {
      api.reload('605382b4', component.options)
    }
    module.hot.accept("./SysTeacherAvailabilityCustomRange.vue?vue&type=template&id=605382b4", function () {
      api.rerender('605382b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/availability/components/SysTeacherAvailabilityCustomRange.vue"
export default component.exports